export const SET_USERINFO = 'SET_USERINFO'
export const LOG_OUT = 'LOG_OUT'
